var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/video-tile.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/video-tile.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("videoUrl")) {
var t_4 = t_1.videoUrl;
} else {
cb(new Error("cannot import 'videoUrl'")); return;
}
context.setVariable("videoUrl", t_4);
output += "\n\n";
var macro_t_5 = runtime.makeMacro(
["videoAsset", "faceoutImage", "productSlug", "shouldShowVideoOnHover"], 
[], 
function (l_videoAsset, l_faceoutImage, l_productSlug, l_shouldShowVideoOnHover, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("videoAsset", l_videoAsset);
frame.set("faceoutImage", l_faceoutImage);
frame.set("productSlug", l_productSlug);
frame.set("shouldShowVideoOnHover", l_shouldShowVideoOnHover);
var t_6 = "";if(l_videoAsset && runtime.memberLookup((l_videoAsset),"id") && l_faceoutImage) {
t_6 += runtime.suppressValue(env.getFilter("safe").call(context, l_faceoutImage), env.opts.autoescape);
t_6 += "\n\n        ";
var t_7;
t_7 = (l_shouldShowVideoOnHover?"js-playable-tile-video":"c-product-tile-controls__video-wrap--hidden");
frame.set("displayVideoClass", t_7, true);
if(frame.topLevel) {
context.setVariable("displayVideoClass", t_7);
}
if(frame.topLevel) {
context.addExport("displayVideoClass", t_7);
}
t_6 += "\n\n        ";
var t_8;
t_8 = (lineno = 10, colno = 32, runtime.callWrap(t_4, "videoUrl", context, [])) + "" + runtime.memberLookup((l_videoAsset),"id") + "" + ".mp4";
frame.set("videoSrc", t_8, true);
if(frame.topLevel) {
context.setVariable("videoSrc", t_8);
}
if(frame.topLevel) {
context.addExport("videoSrc", t_8);
}
t_6 += "\n        ";
var t_9;
t_9 = (l_shouldShowVideoOnHover?runtime.contextOrFrameLookup(context, frame, "videoSrc"):"");
frame.set("activeVideoSrc", t_9, true);
if(frame.topLevel) {
context.setVariable("activeVideoSrc", t_9);
}
if(frame.topLevel) {
context.addExport("activeVideoSrc", t_9);
}
t_6 += "\n\n        ";
var t_10;
t_10 = (runtime.memberLookup((l_videoAsset),"rule") == "COLOR" && runtime.memberLookup((l_videoAsset),"colorId")?runtime.memberLookup((l_videoAsset),"colorId"):"");
frame.set("faceoutColorRule", t_10, true);
if(frame.topLevel) {
context.setVariable("faceoutColorRule", t_10);
}
if(frame.topLevel) {
context.addExport("faceoutColorRule", t_10);
}
t_6 += "\n\n        <video\n            class=\"c-product-tile-controls__video-wrap\n                js-product-tile-video ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "displayVideoClass"), env.opts.autoescape);
t_6 += "\"\n            data-tracking-slug=\"";
t_6 += runtime.suppressValue(l_productSlug, env.opts.autoescape);
t_6 += "\"\n            muted\n            playsinline\n            data-video-id=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((l_videoAsset),"id"), env.opts.autoescape);
t_6 += "\"\n            data-video-src=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "videoSrc"), env.opts.autoescape);
t_6 += "\"\n            data-facout-color-rule=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "faceoutColorRule"), env.opts.autoescape);
t_6 += "\"\n            preload=\"none\">\n\n           <source src=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "activeVideoSrc"), env.opts.autoescape);
t_6 += "\" type=\"video/mp4\" />\n\n        </video>\n\n    ";
;
}
else {
t_6 += "\n\n    ";
;
}
t_6 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_6);
});
context.addExport("videoTile");
context.setVariable("videoTile", macro_t_5);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/video-tile.j2"] , dependencies)